import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';

// TODO: Confirm and define the type of APIError
export type APIError = unknown;

export const SHOW_API_ERROR = createAction<APIError>('API_ERROR');
export const CLEAR_API_ERROR = createAction('CLEAR_API_ERROR');

export const showAPIError =
  (error: APIError): AppThunk =>
  (dispatch) =>
    dispatch(SHOW_API_ERROR(error));

export const clearAPIError = (): AppThunk => (dispatch) => dispatch(CLEAR_API_ERROR());
